import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/home/LoginView.vue'
import axios from "axios";
import { Role } from "@/utils/role";

let instance = ''

instance = axios.create({baseURL: 'https://assistencia.zagonel.com.br/api-assistencia/'})

if (document.URL.indexOf('localhost') !== -1) {
  instance = axios.create({baseURL: 'http://localhost:9350'})
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/register',
    component: () => import(/* webpackChunkName: "producao" */ '../views/home/RegisterView.vue')
  },
  {
    path: '/assistant',
    component: () => import(/* webpackChunkName: "producao" */ '../views/AssistantView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/order',
    component: () => import(/* webpackChunkName: "producao" */ '../views/OrdersView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/order-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/OrderFormView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/product-selection',
    component: () => import(/* webpackChunkName: "producao" */ '../views/ProductSelectionView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/request',
    component: () => import(/* webpackChunkName: "producao" */ '../views/RequestsView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/Price-Table',
    component: () => import(/* webpackChunkName: "producao" */ '../views/TablePriceView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/request-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/RequestFormView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/remittance',
    component: () => import(/* webpackChunkName: "producao" */ '../views/RemittancesView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/remittance-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/RemittancesAdmView.vue'),
    // meta: { authorize: [Role.Admin] }
  },
  {
    path: '/remittance-adm-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/RemittanceAdmFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/remittance-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/RemittanceFormView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/order-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/OrdersAdmView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/order-form-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/OrderAdmFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/request-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/RequestsAdmView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/request-form-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/RequestAdmFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/mirror',
    component: () => import(/* webpackChunkName: "producao" */ '../views/MirrorView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/mirror-detail-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/MirrorDetailAdmView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/mirror-detail',
    component: () => import(/* webpackChunkName: "producao" */ '../views/MirrorDetailView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/products',
    component: () => import(/* webpackChunkName: "producao" */ '../views/ProductsView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/reports',
    component: () => import(/* webpackChunkName: "producao" */ '../views/ReportsView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/task-reports',
    component: () => import(/* webpackChunkName: "producao" */ '../views/reports/ReportTasks.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/complaints-reports',
    component: () => import(/* webpackChunkName: "producao" */ '../views/reports/complaintsReports.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/product-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/ProductFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/price-list',
    component: () => import(/* webpackChunkName: "producao" */ '../views/PriceListView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/price-list-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/PriceListFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/taxes',
    component: () => import(/* webpackChunkName: "producao" */ '../views/TaxesView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/taxe-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/TaxesFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/defects',
    component: () => import(/* webpackChunkName: "producao" */ '../views/DefectsView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/defects-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/DefectsFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/parts',
    component: () => import(/* webpackChunkName: "producao" */ '../views/PartsView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/parts-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/PartsFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/account',
    component: () => import(/* webpackChunkName: "producao" */ '../views/AccountsView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/account-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/AccountsFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/alerts',
    component: () => import(/* webpackChunkName: "producao" */ '../views/AlertView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/alert-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/AlertFormView.vue'),
    meta: { authorize: [Role.User] }
  },
  {
    path: '/alerts-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/AlertAdmView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/tickets',
    component: () => import(/* webpackChunkName: "producao" */ '../views/TicketsView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/adm-charts',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/ChartsView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/assist-charts',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/ChartsAssistView.vue'),
    meta: { authorize: [Role.Assist] }
  },
  {
    path: '/assist-notice',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/AssistNotice.vue'),
    meta: { authorize: [Role.Assist] }
  },
  {
    path: '/alert-form-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/AlertFormAdmView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/report-remittances',
    component: () => import(/* webpackChunkName: "producao" */ '../views/reports/ReportRemittance.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/print',
    component: () => import(/* webpackChunkName: "producao" */ '../views/PrintOrderFormView.vue'),
    meta: { authorize: [Role.Admin] }
  },
  {
    path: '/panel',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/PanelView.vue'),
    // meta: { authorize: [Role.User] }
  },
  {
    path: '/details',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/DetailsView.vue'),
    // meta: { authorize: [Role.Admin] }
  },
  {
    path: '/check-list',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/CheckListView.vue'),
    // meta: { authorize: [Role.Admin] }
  },
  {
    path: '/ratting',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/RattingView.vue'),
    // meta: { authorize: [Role.Admin] }
  },
  {
    path: '/prospect-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/Prospects/ProspectAssist.vue'),
    // meta: { authorize: [Role.Admin] }
  },
  {
    path: '/prospects',
    component: () => import(/* webpackChunkName: "producao" */ '../views/external-assistant/Prospects/ProspectList'),
    // meta: { authorize: [Role.Admin] }
  },
  {
    path: '/prospects-adm',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm/Prospects/ProspectList'),
    // meta: { authorize: [Role.Admin] }
  },
  {
    path: '/prospects-status-adm-list',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm/Prospects/ProspectStatusList'),
    // meta: { authorize: [Role.Admin] }
  },
  // {
  //   path: '/teste',
  //   component: () => import(/* webpackChunkName: "producao" */ '../views/testeView.vue'),
  //   // meta: { authorize: [Role.Admin] }
  // },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "producao" */ '../views/home/LoginView.vue')
  },
  {
    path: '/menu-adm-lumination',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/HomeAdmIlumination'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/order-adm-ilumination',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/orders-adm/index'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/ilumination-order-adm-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/orders-adm/order-adm-form'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/ilumination-adm-products',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/products/index'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/ilumination-adm-price-list',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/price-list/index'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/ilumination-adm-videos',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/videos/index'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/ilumination-adm-product-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/products/product-form'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/shipping-adm-ilumination',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/shippings/index'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/ilumination-adm-reports',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/reports/index'),
    meta: { authorize: [Role.admIl] }
  },
  {
    path: '/menu-lumination',
    component: () => import(/* webpackChunkName: "producao" */ '../views/assistant-ilumination/orders/index'),
    meta: { authorize: [Role.IlAssist] }
  },
  {
    path: '/order-ilumination',
    component: () => import(/* webpackChunkName: "producao" */ '../views/assistant-ilumination/orders/index'),
    meta: { authorize: [Role.IlAssist] }
  },
  {
    path: '/ilumination-order-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/assistant-ilumination/orders/order-form'),
    meta: { authorize: [Role.IlAssist] }
  },
  {
    path: '/shipping-ilumination',
    component: () => import(/* webpackChunkName: "producao" */ '../views/assistant-ilumination/shippings/index'),
    meta: { authorize: [Role.IlAssist] }
  },
  {
    path: '/shipping-order-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/assistant-ilumination/shippings/shipping-form'),
    meta: { authorize: [Role.IlAssist] }
  },
  {
    path: '/ilumination-products',
    component: () => import(/* webpackChunkName: "producao" */ '../views/assistant-ilumination/products/index'),
    meta: { authorize: [Role.IlAssist] }
  },
  {
    path: '/ilumination-product-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/assistant-ilumination/products/product-form'),
    meta: { authorize: [Role.IlAssist] }
  },
  {
    path: '/ilumination-adm-video-form',
    component: () => import(/* webpackChunkName: "producao" */ '../views/adm-ilumination/videos/video-form'),
    meta: { authorize: [Role.IlAssist] }
  },
  {
    path: '/ilumination-videos',
    component: () => import(/* webpackChunkName: "producao" */ '../views/assistant-ilumination/videos/index'),
    meta: { authorize: [Role.IlAssist] }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {

  const token = localStorage.getItem('x-access-token')

  instance.defaults.headers.common['x-access-token'] = token

  const { authorize } = to.meta;


  if (authorize) {
    if (!token) {
      // not logged in so redirect to login page with the return url
      return next({ path: "/", query: { returnUrl: '/' } });
    }

    const result  = await instance.get('/token').then(result => {
      return result
    });

    // check if route is restricted by role
    if (authorize.length && !authorize.includes(result.data.role)) {
      // role not authorised so redirect to home page
      return next({ path: "/" });
    }
  }

  next()
})

export default router
